import { useState, useEffect, useCallback } from "react";

const useOrderData = (userId) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const API_URL = process.env.REACT_APP_API;

  const fetchOrderData = useCallback(async () => {
    // Só faz a requisição se tiver um userId válido
    if (!userId) {
      setOrders([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await fetch(API_URL + "pedido-editora-usuario-id/" + userId);
      if (!response.ok) {
        throw new Error("Erro ao obter os dados dos pedidos.");
      }
      const data = await response.json();
      setOrders(data || []);
    } catch (error) {
      setError(error.message);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  }, [userId, API_URL]);

  useEffect(() => {
    fetchOrderData();
  }, [fetchOrderData]);

  // `refetch` permite atualizar a lista após ações (ex.: solicitar cancelamento)
  // sem depender de marcações locais para refletir o estado real do backend.
  return { orders, loading, error, refetch: fetchOrderData };
};

export default useOrderData;
